import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { Icon } from '../icons';
interface Props {
  message: string;
  className?: string; // 결과 블록 wrapper
  messageClassName?: string; // 번역문 <p>
  // 번역문 앞 마커 (없으면 기본 TranslateFilled 아이콘). ex) fanza=기본 아이콘, pandatv='ㄴ'
  marker?: ReactNode;
}

/**
 * 채팅 번역 결과(마커 + 번역문) 한 줄 표시 원자.
 * 배치/스타일은 소비처가 className/marker로 결정한다.
 */
function ChatTranslateResult(t0) {
  const $ = _c(9);
  const {
    message,
    className,
    messageClassName,
    marker
  } = t0;
  let t1;
  if ($[0] !== marker) {
    t1 = marker ?? <Icon eager={true} name="TranslateFilled" size={16} />;
    $[0] = marker;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== message || $[3] !== messageClassName) {
    t2 = <p className={messageClassName}>{message}</p>;
    $[2] = message;
    $[3] = messageClassName;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== className || $[6] !== t1 || $[7] !== t2) {
    t3 = <div className={className}>{t1}{t2}</div>;
    $[5] = className;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}
export default ChatTranslateResult;